

export const ALLCERTIFICATES = [
    {
        id: 0,
        type: 's',
        body: "State of Florida",
        name: "Mathematics Grades 5-9",
        validity: "2019-2024",
      
    },
    {
        id: 1,
        type: 's',
        body: "State of Florida",
        name: " Computer Science Grades K-12",
        validity: "2019-2024",
      
    },
     
    {
        id: 2,
        type: 's',
        body: "State of Florida",
        name: "Business Education Grades 6-12",
        validity: "2019-2024",
      
    },
    {
        id: 3,
        type: 's',
        body: "State of Florida",
        name: "Social Studies Grades 5-9",
        validity: "2019-2024",
      
    },
    {
        id: 4,
        type: 's',
        body: "State of Nevada",
        name: "Mathematics Grades 7-9",
        validity: "2020-2023",
      
    },
    {
        id: 5,
        type: 'l',
        body: "State of Maryland",
        name: "Bar Admission",
        validity: "1996-Present",
      
    },
    {
        id: 6,
        type: 'l',
        body: "State of Colorado",
        name: "Bar Admission",
        validity: "1996-Present",
      
    },
    {
        id: 7,
        type: 'l',
        body: "District of Columbia",
        name: "Bar Admission",
        validity: "1996-Present",
      
    },
    {
        id: 8,
        type: 'l',
        body: "Federal District of Maryland",
        name: "Bar Admission",
        validity: "1996-Present",
      
    },
    {
        id: 9,
        type: 'l',
        body: "Fourth Circuit Court of Appeals,",
        name: "Bar Admission",
        validity: "1996-Present",
      
    },
    {
        id: 10,
        type: 'b',
        body: "State and Federal",
        name: "Five Bar Admissions",
        validity: "1996-Present",
      
    },
    {
        id: 8,
        type: 'b',
        body: "State Departments of Education (Florida, and Nevada)",
        name: "Certified in Math, Computer Science, Business, and Social Studies",
        validity: "2007-2024",
      
    }

]
     
     
   
    
    
    